<template>
  <div class="page_bg agencyProduct_bg">
    <van-sticky>
      <!-- 顶部返回 -->
      <div class="back_top_name  flex-r-sb-c" style=" padding: 0.32rem;font-size: 0.43rem;background: #FFF;">
        <div class="flex-r-c-c" style="width: 2rem;" @click="backPath"><van-icon name="arrow-left"
                                                                                 style="margin-top: 0.06rem;"
        />返回</div>
        <div class="top_name ">{{ brandName }}</div>
        <div style="width: 2rem;" />
      </div>
    </van-sticky>
    <!-- 商品列表 -->
    <MyscrollList ref="myList01" :list="proList" :line-type="1" :is-btn="false"
                  style="margin-top: 0.21rem;padding-bottom: 4rem;" @myload="proload"
    >
      <template #default="slotProps">
        <div class="pros_box flex-r-s-c">
          <div class="pros_box_img">
            <van-image width="2.56rem" height="2.56rem" :src="slotProps.item.iconUrl" />
          </div>
          <div class="pros_box_info">
            <div class="info_name van-multi-ellipsis--l2">{{ slotProps.item.name }}</div>
            <div class="info_brand van-ellipsis">{{ slotProps.item.brand }} ||
              {{ slotProps.item.specifications }}</div>
            <div class="info_priceCart flex-r-sb-c">
              <div class="price"><span style="font-size: 0.29rem;">￥</span>{{ slotProps.item.price }}</div>
              <!-- v-if="slotProps.item.priceNum > 0 || slotProps.item.priceNum === ''" -->
              <van-stepper v-if="slotProps.item.priceNum > 0 || slotProps.item.priceNum === ''"
                           v-model="slotProps.item.priceNum"
                           :step="slotProps.item.multiplyQuantity === 1 ? slotProps.item.minQuantity : 1" :min="0"
                           integer :allow-empty="true" input-width="1rem" button-size="0.5rem" theme="round"
                           @plus="plusSteeper(slotProps.item)" @minus="minusSteeper(slotProps.item)"
                           @blur="blurInput(slotProps.item)"
              />
              <!-- @change="changeNum($event,slotProps.item)" -->
              <van-icon v-else name="add" color="#0767AB" size="0.55rem" @click="addNum(slotProps.item)" />
            </div>
          </div>
        </div>
      </template>
    </MyscrollList>
    <!-- 底部 -->
    <div class="agencyProduct_bottom">
      <div class="bottom_money flex-r-s-c">
        <div class="money_left flex-r-sa-c" @click="showChange=true">
          <div class="flex-r-c-c" style="font-size: 0.32rem;color: #333;margin-right: 0.21rem;">
            <van-icon name="location" size="0.43rem" color="#F5B599" style="margin-top: 0.05rem;" />{{ cityName }}
          </div>
          <!-- <van-icon name="arrow" size="0.43rem" /> -->
          <van-icon name="play" size="0.43rem" color="#707070" style="transform: rotate(90deg);" />
        </div>
        <div class="money_right">
          当前采购金额为<span style="color: #F20000;">{{ cityStatistics.productAmountTotal }}</span> 元
        </div>
      </div>
      <div class="bottom_sub flex-r-s-s">
        <div class="sub_left">
          <div class="sub_left_msg">
            您已选择 <span style="color: #F20000;">{{ cityStatistics.cityCount }}</span> 个城市
            <br>
            采购金额满 <span style="color: #F20000;">{{ cityStatistics.targetAmountTotal }}</span>元，自动续期
          </div>
        </div>
        <div class="sub_right" @click="subOrder"> 提交订单 </div>
      </div>
    </div>
    <!-- 切换弹出 -->
    <van-popup v-model="showChange" round position="bottom" closeable close-icon="clear">
      <div class="popupChange_box">
        <div class="popupChange_title">选择代理城市</div>
        <div class="popupChange_list">
          <div v-for="(item,index) in cityList" :key="index" class="list_item flex-r-sb-c"
               style="padding-bottom: 0.37rem;padding-top: 0.37rem;"
          >
            <div :class=" item.markType === 1 ? 'list_item_name_actived list_item_name':' list_item_name' ">
              {{ item.cityName }}</div>
            <div />
            <div />
            <van-checkbox :value="item.markType === 1 " @click="changeChoosedCity(item)" />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import './index.scss'
import {
  apiWholesaleAgentRebuy_addDefaultCity, apiWholesaleAgentRebuy_cityList,
  apiWholesaleAgentRebuy_changeCity, apiWholesaleAgentRebuy_cartStatistics,
  apiWholesaleAgentRebuy_updateProduct, apiWholesaleAgentRebuy_productList
} from '@/api/agency'
import MyscrollList from '@/components/MyscrollList'
export default {
  name: 'AgencyProduct',
  components: { MyscrollList },
  data() {
    return {
      brandName: '',
      searchForm: { page: 1, limit: 20, wholesaleAgentBrandId: '' },
      proList: [],

      showChange: false,
      checked: true,
      cityName: '',
      cityList: [],

      cityStatistics: {},

      brandInfo: {},
      brandPrice: []

    }
  },
  created() {
    this.brandName = this.$route.query.brandName
    console.log('this.$router', this.$router)
    this.searchForm.wholesaleAgentBrandId = this.$route.query.wholesaleAgentBrandId
    this.getProList()
    this.loadCityChoosed()
    // this.loadCityInfo(this.$route.query.wholesaleAgentBrandId, true)
  },
  methods: {
    backPath() { window.history.back() },
    // 获取全部城市列表
    getAllCityList() {
      apiWholesaleAgentRebuy_cityList({ page: 1, limit: 999, wholesaleAgentBrandId: this.searchForm.wholesaleAgentBrandId }).then(res => {
        this.cityList = res.data.list
        for (const i in this.cityList) {
          if (this.cityList[i].markType === 1) {
            this.cityName = this.cityList[i].cityName
            break
          }
        }
      })
    },
    // 加载首次城市信息
    loadCityChoosed() {
      apiWholesaleAgentRebuy_addDefaultCity({ wholesaleAgentBrandId: this.searchForm.wholesaleAgentBrandId }).then(res => {
        this.loadTotalInfo()
        this.getAllCityList()
      })
    },
    // 加载统计信息
    loadTotalInfo() { apiWholesaleAgentRebuy_cartStatistics(this.searchForm.wholesaleAgentBrandId).then(res => { this.cityStatistics = res.data }) },
    // 查询事件
    getProList() {
      this.$toast.loading({ message: '加载中...', forbidClick: true, loadingType: 'spinner', duration: 0 })
      apiWholesaleAgentRebuy_productList(this.searchForm).then(res => {
        this.proList = this.proList.concat(res.data.list)
        this.$refs.myList01.load_finished(false)
        this.$toast.clear()
        this.$refs.myList01.load_loading(false)
        // 存localstrong
        if (this.searchForm.page === 1 && res.data.list.length === 0) {
          this.$refs.myList01.load_empty('ser', true)
        } else {
          if (res.data.list.length < 10) { // 数据全部加载完成
            if (res.data.list.length > 0) {
              this.$refs.myList01.load_finished(true)
            }
          }
        }
      })
    },
    proload() {
      this.$refs.myList01.load_loading(true)
      this.$utils.debounce(() => {
        this.searchForm.page = this.searchForm.page + 1
        this.getProList()
        // 加载状态结束
      }, 50)()
    },
    // 步进器
    blurInput(item) {
      console.log('blurInput', item)
      this.$utils.debounce(() => { this.changeNum(item.priceNum, item) }, 100)()
    },
    addNum(item) {
      console.log(item)
      apiWholesaleAgentRebuy_updateProduct({
        wholesaleAgentBrandId: this.searchForm.wholesaleAgentBrandId,
        productId: item.productId, priceNum: parseInt(item.minQuantity)
      }).then(res => {
        item.priceNum = parseInt(item.minQuantity)
        this.cityStatistics.productAmountTotal = res.data.productAmountTotal
      })
    },
    plusSteeper(item) {
      console.log('plusSteeper', item)
      var step = item.multiplyQuantity === 1 ? item.minQuantity : 1
      var value = parseInt(item.priceNum) + step
      this.$utils.debounce(() => { this.changeNum(value, item) }, 100)()
    },
    minusSteeper(item) {
      console.log('minusSteeper', item)
      var step = item.multiplyQuantity === 1 ? item.minQuantity : 1
      var value = parseInt(item.priceNum) - step
      this.$utils.debounce(() => { this.changeNum(value, item) }, 100)()
    },
    // 修改数量
    changeNum(val, item) {
      console.log('changeNum', val, item)
      // 判断当前修改值是否小于最低起售数
      var flag = parseInt(val) >= parseInt(item.minQuantity)
      console.log('changeNumflag ', flag)
      apiWholesaleAgentRebuy_updateProduct({
        wholesaleAgentBrandId: this.searchForm.wholesaleAgentBrandId,
        productId: item.productId, priceNum: flag ? parseInt(val) : 0
      }).then(res => {
        item.priceNum = flag ? parseInt(val) : 0
        this.cityStatistics.productAmountTotal = res.data.productAmountTotal
        if (!flag) {
          this.$toast({ message: '该商品最小起售数为' + item.minQuantity, duration: 2 * 1000 })
        }
      })
      // 更新统计信息
      // this.loadTotalInfo()
      this.$forceUpdate()
    },

    // 选择城市
    changeChoosedCity(item) {
      const parms = {
        wholesaleAgentBrandId: this.searchForm.wholesaleAgentBrandId,
        cityId: item.cityId
      }
      const type = item.markType === 1 ? 'del' : 'add'
      apiWholesaleAgentRebuy_changeCity(parms, type).then(res => {
        item.markType = item.markType === 1 ? 0 : 1
        for (const i in this.cityList) {
          if (this.cityList[i].markType === 1) {
            this.cityName = this.cityList[i].cityName
            break
          }
        }
        // 更新统计信息
        this.loadTotalInfo()
      })
    },
    subOrder() {
      // 判断是否满足提交资格
      apiWholesaleAgentRebuy_cartStatistics(this.searchForm.wholesaleAgentBrandId).then(res => {
        if (res.data.submitFlag === 1) {
          this.$router.replace(`/order/subOrder?type=8&wholesaleAgentBrandId=${this.searchForm.wholesaleAgentBrandId}`)
        } else {
          this.$toast({ message: '当前商品采购金额未达到代理要求，无法提交订单', duration: 2 * 1000 })
        }
      })
    }
  }
}
</script>

<style>
</style>
